import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'print',

  data: function () {
    return {
      cond: {
        doc_type: 0,
        pdf_header: 0,
        report_type: '',

        shop_id: null,
        patient_id: this.$t('all_list.id'),
        facility_id: this.$t('all_list.id'),
        clinic_id: this.$t('all_list.id'),
        clinic_post: null,
        careoffice_id: this.$t('all_list.id'),
        careoffice_post: null,

        plan_date_from: null,
        plan_date_to: null,
        prescribe_date_from: null,
        prescribe_date_to: null,
        delivery_date_from: null,
        delivery_date_to: null,
        make_date_from: null,
        make_date_to: null,

        plan_sort_field1: null,
        plan_sort_field2: null,
        plan_sort_field3: null,
        report_sort_field1: null,
        report_sort_field2: null,
        report_sort_field3: null,
        sort_order1: null,
        sort_order2: null,
        sort_order3: null,
      },

      // コンボボックス用
      patientName: '',
      facilityName: '',
      clinicName: '',
      careOfficeName: '',

      // 正常入力値保持用
      ac: {
        patient_name: '',
        facility_name: '',
        clinic_name: '',
        careoffice_name: ''
      },

      // 確認ダイアログ用
      confirmTitle: null,
      confirmMessage: null,
      confirmOnYes: () => {},
      confirmOnNo: () => {},

      // ダウンロードダイアログ用
      downloadTitle: null,
      downloadMessage: null,
      downloadUrl: null,
      downloadOnClickLink: () => {},
      downloadOnCancel: () => {},

      downloadMode: null,
      utils: utils
    }
  },

  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    // オートコンプリートイベント削除
    utils.autocompleteEventRemove({$: $, elem: '#patient_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem: '#facility_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem: '#clinic_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem: '#careoffice_name_autocomplete'})
    next()
  },

  created: function () {
    this.clearAllList()

    var ssDocType = window.sessionStorage.getItem('print-docType')
    if (!!ssDocType) {
      this.cond.doc_type = ssDocType
    }

    this.initSort('created')
    this.cond.report_type = this.$t('all_list.id')

    var ssShopID = window.sessionStorage.getItem('print-shopID')
    var ssReportType = window.sessionStorage.getItem('print-reportType')
    var ssPatientName = window.sessionStorage.getItem('print-patientName')
    var ssPdfHeader = window.sessionStorage.getItem('print-pdfHeader')
    var ssFacilityName = window.sessionStorage.getItem('print-facilityName')
    var ssDeliveryDateFrom = window.sessionStorage.getItem('print-deliveryDateFrom')
    var ssDeliveryDateTo = window.sessionStorage.getItem('print-deliveryDateTo')
    var ssClinicName = window.sessionStorage.getItem('print-clinicName')
    var ssClinicPost = window.sessionStorage.getItem('print-clinicPost')
    var ssMakeDateFrom = window.sessionStorage.getItem('print-makeDateFrom')
    var ssMakeDateTo = window.sessionStorage.getItem('print-makeDateTo')
    var ssCareOfficeName = window.sessionStorage.getItem('print-careOfficeName')
    var ssCareOfficePost = window.sessionStorage.getItem('print-careOfficePost')
    var ssPrescribeDateFrom = window.sessionStorage.getItem('print-prescribeDateFrom')
    var ssPrescribeDateTo = window.sessionStorage.getItem('print-prescribeDateTo')
    var ssPlanDateFrom = window.sessionStorage.getItem('print-planDateFrom')
    var ssPlanDateTo = window.sessionStorage.getItem('print-planDateTo')
    var ssReportSortField1 = window.sessionStorage.getItem('print-reportSortField1')
    var ssReportSortField2 = window.sessionStorage.getItem('print-reportSortField2')
    var ssReportSortField3 = window.sessionStorage.getItem('print-reportSortField3')
    var ssPlanSortField1 = window.sessionStorage.getItem('print-planSortField1')
    var ssPlanSortField2 = window.sessionStorage.getItem('print-planSortField2')
    var ssPlanSortField3 = window.sessionStorage.getItem('print-planSortField3')
    var ssSortOrder1 = window.sessionStorage.getItem('print-sortOrder1')
    var ssSortOrder2 = window.sessionStorage.getItem('print-sortOrder2')
    var ssSortOrder3 = window.sessionStorage.getItem('print-sortOrder3')
    if (!!ssShopID) {
      if (ssShopID === 'null') {
        this.cond.shop_id = null
      } else {
        this.cond.shop_id = ssShopID
      }
    } else {
      this.cond.shop_id = this.$store.getters.currentShopId
    }
    if (!!ssReportType) {
      this.cond.report_type = ssReportType
    }
    if (!!ssPlanDateFrom) {
      this.planDateFrom = ssPlanDateFrom
    }
    if (!!ssPlanDateTo) {
      this.planDateTo = ssPlanDateTo
    }
    if (!!ssPatientName) {
      this.patientName = ssPatientName
    }
    if (!!ssPdfHeader) {
      this.cond.pdf_header = ssPdfHeader
    }
    if (!!ssFacilityName) {
      this.facilityName = ssFacilityName
    }
    if (!!ssDeliveryDateFrom){
      this.deliveryDateFrom = ssDeliveryDateFrom
    }
    if (!!ssDeliveryDateTo) {
      this.deliveryDateTo = ssDeliveryDateTo
    }
    if (!!ssClinicName) {
      this.clinicName = ssClinicName
    }
    if (!!ssClinicPost) {
      this.cond.clinic_post = ssClinicPost
    }
    if (!!ssMakeDateFrom) {
      this.makeDateFrom = ssMakeDateFrom
    }
    if (!!ssMakeDateTo) {
      this.makeDateTo = ssMakeDateTo
    }
    if (!!ssCareOfficeName) {
      this.careOfficeName = ssCareOfficeName
    }
    if (!!ssCareOfficePost) {
      this.cond.careoffice_post = ssCareOfficePost
    }
    if (!!ssPrescribeDateFrom) {
      this.prescribeDateFrom = ssPrescribeDateFrom
    }
    if (!!ssPrescribeDateTo) {
      this.prescribeDateTo = ssPrescribeDateTo
    }
    if (!!ssReportSortField1) {
      this.cond.report_sort_field1 = ssReportSortField1
    }
    if (!!ssReportSortField2) {
      this.cond.report_sort_field2 = ssReportSortField2
    }
    if (!!ssReportSortField3) {
      this.cond.report_sort_field3 = ssReportSortField3
    }
    if (!!ssPlanSortField1) {
      this.cond.report_sort_field1 = ssReportSortField1
    }
    if (!!ssPlanSortField2) {
      this.cond.report_sort_field2 = ssReportSortField2
    }
    if (!!ssPlanSortField3) {
      this.cond.report_sort_field3 = ssReportSortField3
    }
    if (!!ssSortOrder1) {
      this.cond.sort_order1 = ssSortOrder1
    }
    if (!!ssSortOrder2) {
      this.cond.sort_order2 = ssSortOrder2
    }
    if (!!ssSortOrder3) {
      this.cond.sort_order3 = ssSortOrder3
    }


    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    // オートコンプリートイベント
    utils.autocompleteEvent({$:$, elem:'#patient_name_autocomplete',    search:() => {}, searchParams:false, searchAutocomplete:this.getPatients,    setSearchData:this.setSearchPatient,    clear: this.clearPatients})
    utils.autocompleteEvent({$:$, elem:'#clinic_name_autocomplete',     search:() => {}, searchParams:false, searchAutocomplete:this.getClinics,     setSearchData:this.setSearchClinic,     clear: this.clearClinics})
    utils.autocompleteEvent({$:$, elem:'#careoffice_name_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:this.getCareOffices, setSearchData:this.setSearchCareOffice, clear: this.clearCareOffices})
    utils.autocompleteEvent({$:$, elem:'#facility_name_autocomplete',   search:() => {}, searchParams:false, searchAutocomplete:this.getFacilities,  setSearchData:this.setSearchFacility,   clear: this.clearFacilities})
  },


  computed: {
    /** 通知 */
    notify() {
      return this.$store.getters.downloadNotify
    },

    /** 患者 */
    patients () {
      var all = [{id: this.$t('all_list.id'), attributes: {'patient-name': this.$t('all_list.name')}}]
      var list = this.$store.getters.patients
      return (list && list.length > 0) ? all.concat(list) : null
    },
    /** 施設 */
    facilities () {
      var all = [{id: this.$t('all_list.id'), attributes: {'facility-name': this.$t('all_list.name')}}]
      var list = this.$store.getters.facilitiesAutocomplete
      return (list && list.length > 0) ? all.concat(list) : null
    },
    /** 介護支援事業所 */
    careOffices () {
      var all = [{id: this.$t('all_list.id'), attributes: {'careoffice-name': this.$t('all_list.name')}}]
      var list = this.$store.getters.careOfficesAutocomplete
      return (list && list.length > 0) ? all.concat(list) : null
    },
    /** クリニック */
    clinics () {
      var all = [{id: this.$t('all_list.id'), attributes: {'clinic-name': this.$t('all_list.name')}}]
      var list = this.$store.getters.clinicsAutocomplete
      return (list && list.length > 0) ? all.concat(list) : null
    },
    /** 店舗 */
    shops () {
      return this.$store.getters.shops.filter((o) => {return o.id != null}) // 全店舗は不可
    },
    /** タイプ */
    reportTypes () {
      return this.$t('print-all.report_types')
    },
    /** 報告書 並び順 */
    reportSortFields () {
      return this.$t('print-all.report_sort_fields')
    },
    /** 計画書 並び順 */
    planSortFields () {
      return this.$t('print-all.plan_sort_fields')
    },

    /** 各日付 (和暦) */
    planDateFrom: {
      get: function () {return this.getWareki(this.cond.plan_date_from)},
      set: function (v) {this.cond.plan_date_from = this.getSeireki(v)}
    },
    planDateTo: {
      get: function () {return this.getWareki(this.cond.plan_date_to)},
      set: function (v) {this.cond.plan_date_to = this.getSeireki(v)}
    },
    prescribeDateFrom: {
      get: function () {return this.getWareki(this.cond.prescribe_date_from)},
      set: function (v) {this.cond.prescribe_date_from = this.getSeireki(v)}
    },
    prescribeDateTo: {
      get: function () {return this.getWareki(this.cond.prescribe_date_to)},
      set: function (v) {this.cond.prescribe_date_to = this.getSeireki(v)}
    },
    deliveryDateFrom: {
      get: function () {return this.getWareki(this.cond.delivery_date_from)},
      set: function (v) {this.cond.delivery_date_from = this.getSeireki(v)}
    },
    deliveryDateTo: {
      get: function () {return this.getWareki(this.cond.delivery_date_to)},
      set: function (v) {this.cond.delivery_date_to = this.getSeireki(v)}
    },
    makeDateFrom: {
      get: function () {return this.getWareki(this.cond.make_date_from)},
      set: function (v) {this.cond.make_date_from = this.getSeireki(v)}
    },
    makeDateTo: {
      get: function () {return this.getWareki(this.cond.make_date_to)},
      set: function (v) {this.cond.make_date_to = this.getSeireki(v)}
    },
  },


  methods: {
    /** 患者 */
    getPatients: function () {
      this.cond.patient_id = null
      this.$store.dispatch('PATIENT_SEARCH', { data: {
        'shop_id': this.cond.shop_id,
        'patient_name': this.trim(this.patientName),
        'all_get': true,
      }})
    },
    clearPatients: function () {
      if (this.ac.patient_name !== this.patientName) {
        this.patientName = this.ac.patient_name
        this.$store.dispatch('DOWNLOAD_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.$store.dispatch('PATIENT_CLEAR', 0)
    },
    setSearchPatient: function (id, name) {
      this.cond.patient_id = id
      this.patientName = name
      this.ac.patient_name = name
      this.$store.dispatch('PATIENT_CLEAR', 0)
    },

    /** 施設 */
    getFacilities: function () {
      this.$store.dispatch('FACILITY_SEARCH', {
        data: {
          'facility_name': this.trim(this.facilityName),
          'shop_id': this.cond.shop_id,
          'all_get': true,
        },
        autocomplete: true
      })
    },
    clearFacilities: function () {
      if (this.ac.facility_name !== this.facilityName) {
        this.facilityName = this.ac.facility_name
        this.$store.dispatch('DOWNLOAD_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 0)
    },
    setSearchFacility: function (facilityId, facilityName) {
      this.cond.facility_id = facilityId
      this.facilityName = facilityName
      this.ac.facility_name = facilityName
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 0)
    },

    /** 介護支援事業所 */
    getCareOffices: function () {
      this.$store.dispatch('CARE_OFFICE_SEARCH', {
        data: {
          'careoffice_name': this.trim(this.careOfficeName),
          'shop_id': this.cond.shop_id,
          'all_get': true,
        },
        autocomplete: true
      })
    },
    clearCareOffices: function () {
      if (this.ac.careoffice_name !== this.careOfficeName) {
        this.careOfficeName = this.ac.careoffice_name
        this.$store.dispatch('DOWNLOAD_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
    },
    setSearchCareOffice: function (id, name) {
      this.cond.careoffice_id = id
      this.careOfficeName = name
      this.ac.careoffice_name = name
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
    },

    /** クリニック */
    getClinics: function () {
      this.clearAllList()
      this.$store.dispatch('CLINIC_SEARCH', {
        data: {
          'clinic_name': this.trim(this.clinicName),
          'shop_id': this.cond.shop_id,
          'all_get': true,
        },
        autocomplete: true
      })
    },
    clearClinics: function () {
      if (this.ac.clinic_name !== this.clinicName) {
        this.clinicName = this.ac.clinic_name
        this.$store.dispatch('DOWNLOAD_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 0)
    },
    setSearchClinic: function (id, name) {
      this.cond.clinic_id = id
      this.clinicName = name
      this.ac.clinic_name = name
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 0)
    },

    /** 店舗 */
    onChangeShop: function () {
      window.sessionStorage.setItem('print-shopID', this.cond.shop_id)
      // 店舗の変更時、患者をクリア
      this.cond.patient_id = this.$t('all_list.id')
      this.patientName = this.$t('all_list.name')
      this.ac.patient_name = this.$t('all_list.name')
      window.sessionStorage.removeItem('print-patientName')
    },
    onChangeReportType: function () {
      if (!!this.cond.report_type) {
        window.sessionStorage.setItem('print-reportType', this.cond.report_type)
      } else {
        window.sessionStorage.removeItem('print-reportType')
      }
    },
    onChangePatientName: function () {
      if (!!this.patientName) {
        window.sessionStorage.setItem('print-patientName', this.patientName)
      } else {
        window.sessionStorage.removeItem('print-patientName')
      }
    },
    onChangePdfHeader: function () {
      if (!!this.cond.pdf_header) {
        window.sessionStorage.setItem('print-pdfHeader', this.cond.pdf_header)
      } else {
        window.sessionStorage.removeItem('print-pdfHeader')
      }
    },
    onChangeFacilityName: function () {
      if (!!this.facilityName) {
        window.sessionStorage.setItem('print-facilityName', this.facilityName)
      } else {
        window.sessionStorage.setItem('print-facilityName')
      }
    },
    onChangeDeliveryDateFrom: function () {
      if (!!this.deliveryDateFrom) {
        window.sessionStorage.setItem('print-deliveryDateFrom', this.deliveryDateFrom)
      } else {
        window.sessionStorage.setItem('print-deliveryDateFrom')
      }
    },
    onChangeDeliveryDateTo: function () {
      if (!!this.deliveryDateTo) {
        window.sessionStorage.setItem('print-deliveryDateTo', this.deliveryDateTo)
      } else {
        window.sessionStorage.setItem('print-deliveryDateTo')
      }
    },
    onChangeClinicName: function () {
      if (!!this.clinicName) {
        window.sessionStorage.setItem('print-clinicName', this.clinicName)
      } else {
        window.sessionStorage.setItem('print-clinicName')
      }
    },
    onChangeClinicPost: function () {
      if (!!this.cond.clinic_post) {
        window.sessionStorage.setItem('print-clinicPost', this.cond.clinic_post)
      } else {
        window.sessionStorage.removeItem('print-clinicPost')
      }
    },
    onChangeMakeDateFrom: function () {
      if (!!this.makeDateFrom) {
        window.sessionStorage.setItem('print-makeDateFrom', this.makeDateFrom)
      } else {
        window.sessionStorage.removeItem('print-makeDateFrom')
      }
    },
    onChangeMakeDateTo: function () {
      if (!!this.makeDateTo) {
        window.sessionStorage.setItem('print-makeDateTo', this.makeDateTo)
      } else {
        window.sessionStorage.removeItem('print-makeDateTo')
      }
    },
    onChangeCareOfficeName: function () {
      if (!!this.careOfficeName) {
        window.sessionStorage.setItem('print-careOfficeName', this.careOfficeName)
      } else {
        window.sessionStorage.setItem('print-careOfficeName')
      }
    },
    onChangeCareOfficePost: function () {
      if (!!this.cond.careoffice_post) {
        window.sessionStorage.setItem('print-careOfficePost', this.cond.careoffice_post)
      } else {
        window.sessionStorage.removeItem('print-careOfficePost')
      }
    },
    onChangePrescribeDateFrom: function () {
      if (!!this.prescribeDateFrom) {
        window.sessionStorage.setItem('print-prescribeDateFrom', this.prescribeDateFrom)
      } else {
        window.sessionStorage.removeItem('print-prescribeDateFrom')
      }
    },
    onChangePrescribeDateTo: function () {
      if (!!this.prescribeDateTo) {
        window.sessionStorage.setItem('print-prescribeDateTo', this.prescribeDateTo)
      } else {
        window.sessionStorage.removeItem('print-prescribeDateTo')
      }
    },
    onChangePlanDateFrom: function () {
      if (!!this.planDateFrom) {
        window.sessionStorage.setItem('print-planDateFrom', this.planDateFrom)
      } else {
        window.sessionStorage.removeItem('print-planDateFrom')
      }
    },
    onChangePlanDateTo: function () {
      if (!!this.planDateTo) {
        window.sessionStorage.setItem('print-planDateTo', this.planDateTo)
      } else {
        window.sessionStorage.removeItem('print-planDateTo')
      }
    },
    onChangeReportSortField1: function () {
      window.sessionStorage.setItem('print-reportSortField1', this.cond.report_sort_field1)
    },
    onChangeReportSortField2: function () {
      window.sessionStorage.setItem('print-reportSortField2', this.cond.report_sort_field2)
    },
    onChangeReportSortField3: function () {
      window.sessionStorage.setItem('print-reportSortField3', this.cond.report_sort_field3)
    },
    onChangePlanSortField1: function () {
      window.sessionStorage.setItem('print-planSortField1', this.cond.plan_sort_field1)
    },
    onChangePlanSortField2: function () {
      window.sessionStorage.setItem('print-planSortField2', this.cond.plan_sort_field2)
    },
    onChangePlanSortField3: function () {
      window.sessionStorage.setItem('print-planSortField3', this.cond.plan_sort_field3)
    },
    onChangeSortOrder1: function () {
      window.sessionStorage.setItem('print-sortOrder1', this.cond.sort_order1)
    },
    onChangeSortOrder2: function () {
      window.sessionStorage.setItem('print-sortOrder2', this.cond.sort_order2)
    },
    onChangeSortOrder3: function () {
      window.sessionStorage.setItem('print-sortOrder3', this.cond.sort_order3)
    },

    /** 圧縮ファイル・まとめＰＤＦ ( mode: 'zip' or 'pdf' ) */
    onClickZipDown: function (mode) {
      this.downloadMode = mode
      var dispatcher = this.cond.doc_type == 0 ? 'DOWNLOAD_REPORT_SEARCH' : 'DOWNLOAD_PLAN_SEARCH'
      this.$store.dispatch(dispatcher, { data: this.cond, callback: this.confirmDownload })
    },
    confirmDownload: function (data) {
      var list = data.list
      var cond = data.cond
      var zipdown_id = data.zipdown_id
      var docName = this.cond.doc_type == 0 ? this.$t('print-all.report') : this.$t('print-all.plan')
      docName
      if (list.length > 0) {
        // 確認ダイアログ設定
        var self = this
        var dispatcher = this.cond.doc_type == 0 ? 'DOWNLOAD_REPORT' : 'DOWNLOAD_PLAN'
        this.confirmTitle = this.$t('print-all.confirm_title')
        this.confirmMessage = this.$t('print-all.confirm_message', {'count': list.length, 'name': docName})
        this.confirmOnYes = () => {
          // "はい"押下 ⇒ ダウンロード開始
          self.$store.dispatch(
            dispatcher,
            {
              mode: self.downloadMode,
              data: { list: list, pdf_header: cond.pdf_header, zipdown_id: zipdown_id },
              callback: self.onDownload
            }
          )
          // ダウンロード中ダイアログ表示
          self.$refs.downloadBtn.click()
        }
        this.confirmOnNo = () => {}

        // ダウンロードダイアログ設定
        this.downloadUrl = null
        this.downloadTitle = this.$t('print-all.download_title')
        var proc = this.downloadMode == 'zip' ? this.$t('print-all.proc_zip') :this.$t('print-all.proc_build')
        this.downloadMessage = this.$t('print-all.download_message', {'proc': proc })
        this.downloadOnCancel = () => {
          // "キャンセル"押下 ⇒ キャンセル処理実行
          this.$store.dispatch('DOWNLOAD_CANCEL', { data: {zipdown_id: zipdown_id}, callback: () => {} })
          this.$refs.downloadClose.click()
        }
        this.downloadOnClickLink = this.downloadOnCancel

        // 確認ダイアログ表示
        this.$refs.confirmBtn.click()
      } else {
        // メッセージ表示
        this.$store.dispatch('DOWNLOAD_MSG_ALERT', { message_i18n: this.$t('print-all.not_exist_message', {'name': docName}), danger: true })
      }
    },
    onDownload: function (data) {
      this.downloadUrl = data.url
      if (this.downloadMode == 'zip') {
        this.$refs.downloadZipStart.href = data.url
        this.$refs.downloadZipStart.click()
        this.downloadOnCancel()
      }
    },

    /** キャンセル */
    onClickCancel: function () {
      this.$router.push('/')
    },

    /** 並び順初期化 */
    initSort (key) {
      window.sessionStorage.setItem('print-docType', this.cond.doc_type)
      this.cond.plan_sort_field1 = 3
      this.cond.plan_sort_field2 = 6
      this.cond.plan_sort_field3 = 7
      this.cond.report_sort_field1 = 3
      this.cond.report_sort_field2 = 6
      this.cond.report_sort_field3 = 7
      this.cond.sort_order1 = 1
      this.cond.sort_order2 = 1
      this.cond.sort_order3 = 1
      if (key !== 'created') {
        window.sessionStorage.removeItem('print-reportSortField1')
        window.sessionStorage.removeItem('print-reportSortField2')
        window.sessionStorage.removeItem('print-reportSortField3')
        window.sessionStorage.removeItem('print-planSortField1')
        window.sessionStorage.removeItem('print-planSortField2')
        window.sessionStorage.removeItem('print-planSortField3')
        window.sessionStorage.removeItem('print-sortOrder1')
        window.sessionStorage.removeItem('print-sortOrder2')
        window.sessionStorage.removeItem('print-sortOrder3')
      }
    },

    /** 前ページに戻る */
    goBack: function () {
      this.$router.push({ name: this.backUrlName})
    },

    /** 全リストデータをクリア */
    clearAllList: function () {
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('PATIENT_CLEAR', 0)
    },
    lazyExec: function (func) {
      // setTimeout(func}, utils.key_delay)
      this.$nextTick(func)
    },

    /** 手入力値から、なし/全て を除外 */
    trim: function (name) {
      if (!name) return ''
      if (name.trim() == this.$t('none_list.name')) return ''
      if (name.trim() == this.$t('all_list.name')) return ''
      return name.trim()
    },

    /** 日付 (和暦) 用 */
    getWareki: function (seireki_str) {
      if ((!seireki_str) || isNaN(Date.parse(seireki_str))) {
        return ''
      } else {
        return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
      }
    },
    getSeireki: function (wareki_str) {
      return utils.wareki2Seireki(this.$t, wareki_str, 'y-m-d')
    },
    getHHMM: function (seireki_str) {
      var d = new Date(Date.parse(seireki_str))
      return ("0"+d.getHours()).slice(-2) + ":" + ("0"+d.getMinutes()).slice(-2)
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/print.js